import http from "../../http-common";

const getMy = async () => {
  return await http
    .get("/admin/resource-request/my")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const create = async (resourceRequestData) => {
  return await http
    .post("/admin/resource-request", resourceRequestData)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const get = async (id) => {
  return await http
    .get(`/admin/resource-request/${id}`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getAll = async () => {
  return await http
    .get("/admin/resource-request")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const update = async (id, resourceRequestData) => {
  return await http
    .post(`/admin/resource-request/${id}`, resourceRequestData)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const deleteDraft = async (id) => {
  return await http
    .delete(`/admin/resource-request/${id}`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const submit = async (id, data) => {
  return await http
    .post(`/admin/resource-request/${id}/submit`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const reject = async (id, data) => {
  return await http
    .put(`/admin/resource-request/${id}/reject`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const approve = async (id, data) => {
  return await http
    .put(`/admin/resource-request/${id}/approve`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};



export default {
  create,
  getMy,

  get,
  getAll,
  update,
  delete: deleteDraft,
  submit,
  reject,
  approve,
};
